var React = require('react');

function WarnInline (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t\t.st0 {\n\t\t\tfill: currentColor;\n\t\t}\n\t"),React.createElement("g",{"key":1},React.createElement("path",{"className":"st0","d":"M17,28.2L17,28.2c-1.3,0-2.3-1-2.3-2.2c0-0.6,0.2-1.2,0.6-1.6s1-0.7,1.6-0.7h0c1.2,0,2.2,1,2.3,2.2\n\t\tc0,0.6-0.2,1.2-0.6,1.6C18.2,27.9,17.6,28.2,17,28.2z M15.5,11c0-0.8,0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5v9c0,0.8-0.7,1.5-1.5,1.5\n\t\ts-1.5-0.7-1.5-1.5V11z M33.6,28.3l-14-26.7C19.1,0.6,18.1,0,17,0c-1.1,0-2.1,0.6-2.6,1.6l-14,26.7c-0.5,0.9-0.5,2,0.1,2.9\n\t\tC1,32.1,1.9,32.7,3,32.7h28c1,0,2-0.5,2.6-1.4C34,30.3,34.1,29.2,33.6,28.3z"}))]);
}

WarnInline.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 33.9 32.7","style":{"enableBackground":"new 0 0 33.9 32.7"},"xmlSpace":"preserve"};

module.exports = WarnInline;

WarnInline.default = WarnInline;
